import { formatMonth } from '../lib/dates'
import { cycleLabel } from '../lib/cycles'
import type { CycleClose } from '../db/budget'
import { Icon } from './Icon'
import './CycleLockBanner.css'

/**
 * Le rappel de clôture, présent sur TOUS les écrans tant que le point n'est pas
 * fait.
 *
 * Il ne disparaît pas quand on referme la feuille, et il dit pourquoi l'app est
 * figée. Un verrou sans explication se lit comme une panne : l'utilisateur
 * toucherait un bouton mort sans comprendre, et conclurait que l'app est
 * cassée.
 */
export function CycleLockBanner(
  { close, onOpen }: { close: CycleClose; onOpen: () => void },
) {
  return (
    <div className="lock-banner" role="status">
      <span className="lock-banner-icon" aria-hidden="true">
        <Icon name="lock" size={18} />
      </span>
      <p>
        <strong>
          {close.cycle === 'monthly'
            ? `${formatMonth(close.range.start)} est terminé.`
            : `La ${cycleLabel(close.range, 'weekly')} est terminée.`}
        </strong>
        {' '}Fais le point pour repartir sur des chiffres justes. En attendant,
        rien ne peut être modifié.
      </p>
      <button type="button" onClick={onOpen}>Faire le point</button>
    </div>
  )
}
